// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LoginForm,\n.SignupForm {\n  margin-top: 12px;\n}", "",{"version":3,"sources":["webpack://./querybook/webapp/components/UnauthPage/UnauthPage.scss"],"names":[],"mappings":"AAAA;;EAEI,gBAAA;AACJ","sourcesContent":[".LoginForm,\n.SignupForm {\n    margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
